import { PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'react';

import {
  getCareerRoadMapAssessmentValues,
  upsertCareerRoadMapAssessment,
} from '../../../services/database/career-roadmap-assessment';

import { CareerRoadMapAnswers, CareerRoadMapDto } from './career-roadmap-type';
import { updateCareerRoadMapAsessmentAction } from './career-roadmap.slice';

/**
 * retrieves or updates a pre-employment assessment
 */

export const dispatchGetCareerRoadMapAssessment =
  () =>
  async (dispatch: Dispatch<PayloadAction<CareerRoadMapAnswers>>): Promise<void> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const values: any = await getCareerRoadMapAssessmentValues();
    if (values?.dateOfBirth?.seconds)
      values.dateOfBirth = new Date(values.dateOfBirth.seconds * 1000);
    dispatch(updateCareerRoadMapAsessmentAction(values));
  };

export const dispatchCareerRoadMapAssessment =
  (dto?: CareerRoadMapDto | boolean, key?: keyof CareerRoadMapAnswers) =>
  async (dispatch: Dispatch<PayloadAction<CareerRoadMapAnswers>>): Promise<void> => {
    if (!dto || !key) return;
    const transformedDTO: Partial<CareerRoadMapAnswers> = {
      [key]: dto,
    };
    const values: CareerRoadMapAnswers = await upsertCareerRoadMapAssessment(transformedDTO);

    dispatch(updateCareerRoadMapAsessmentAction(values));
  };
